import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import * as m from './Prefijo.model';
import { OpcionModel } from '../Global/Opcion.model';

import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';


@Component({
	selector: 'prefijo',
	templateUrl: './PrefijoIndex.component.html',
	styleUrls: ['../../../../styles.css']
})


export class PrefijoIndexComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public listaNegocios: Array<OpcionModel>;
	public prefijos: Array<m.PrefijoModel>;

	public form: FormGroup;
	public formErrors: any;
	public cnumcont: OpcionModel;

	public displayedColumns = ['Prefijo', 'Descripcion', 'Editar'];
	public dataDataBase: PrefijosDatabase;
	public dataSource: ExampleDataSource;

	public permisos: any;

	public bloquear: boolean = false;

	public ocultar: boolean = false;
	public mensaje: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	options = [];






	public popoverTitle: string = 'Confirmación';
	public popoverMessage: string = '¿Está seguro de eliminar este registro?';
	/*	public dataDataBase:NegociosDatabase;
		public dataSource:ExampleDataSource;
		*/
	@ViewChild('filter') filter: ElementRef;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog,
		private confirmarEliminacionService: ConfirmarEliminacionService) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.listaNegocios = new Array();
		this.prefijos = new Array();
		//this.permisos = _serviciosGenerales.seguridad.getCrud();
		//console.log('Permisos: ', this.permisos);

		this.cnumcont = new OpcionModel('', "");
		this.form = this.formBuilder.group({
			filtro: [
				{
					value: this.cnumcont.labelOpcion,
					disabled: this.bloquear
				}]
		});

	}




	ngOnInit() {

		this.cargarTabla();

		this.filteredOptions = this.myControl.valueChanges
			.startWith(null)
			.map(val => val ? this.filtro(val) : this.listaNegocios.slice());

	}

	filtro(val: string)//: string[]
	{
		if (val == null) {
			val = "";
		}


		let x = this.listaNegocios.filter(option => (option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1);

		return x;


	}

	eventoConsulta() {
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-'));
		console.log(this.cnumcont);

		this.consultarPrefijos();
	}


	cargarTabla() {
		this._serviciosGenerales.get('listaNegocios', { param: 0 }).subscribe(

			result => {

				this.listaNegocios = new Array();

				for (let x in result)
					this.listaNegocios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));

				this._route.params.subscribe(params => {
					if (params['cnumcont'] != undefined) {
						for (let x in this.listaNegocios) {
							if (this.listaNegocios[x].idOpcion.trim().toLowerCase() == params['cnumcont'].trim().toLowerCase()) {
								this.cnumcont.labelOpcion = this.listaNegocios[x].idOpcion + ' - ' + this.listaNegocios[x].labelOpcion;
								this.cnumcont.idOpcion = this.listaNegocios[x].idOpcion;
							}
						}
						console.log(this.cnumcont.labelOpcion);
						this.consultarPrefijos();
						this.bloquear = true;
					}

					this.form = this.formBuilder.group({
						filtro: [
							{
								value: this.cnumcont.labelOpcion,
								disabled: this.bloquear && !!(params['desdeContrato'])
							}]
					});

				})


			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el prefijo", "X");
			}
		);
	}


	consultarPrefijos() {
		console.log('Entró .... ', this.cnumcont);
		this._serviciosGenerales.get('listadoPrefijos', { cnumcont: this.cnumcont.idOpcion }).subscribe(


			result => {
				this.dataDataBase = new PrefijosDatabase();
				for (let x in result) {
					this.dataDataBase.addPrefijo(new m.PrefijoModel(
						new m.MchPrefijosId(result[x].cnumcont, result[x].cprefijo, result[x].ntipoempresa),
						new m.DefTiposprefijos(result[x].ntipodoc),
						0,
						new m.ParamFormatos(""),
						new m.ParamDetallefactura(""),
						new m.ParamNegocios(new m.ParamNegociosId("", 0)),
						"", "", "", "", "", "", "", result[x].cdescripcion, 0, "", result[x].bloquear,0,0,2));
				}

				this.dataSource = new ExampleDataSource(this.dataDataBase);

			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el prefijo", "X");
			}
		);
	}


	editar(prefijo: m.PrefijoModel) {
		this._router.navigate(['/Prefijo', this.cnumcont.idOpcion, prefijo.id.cprefijo]);
	}

	verConceptos(prefijo: m.PrefijoModel) {
		this._router.navigate(['/Concepto/i', this.cnumcont.idOpcion, prefijo.id.cprefijo, '1']);
	}

	verMandantes(prefijo:m.PrefijoModel){
		this._router.navigate(['/Mandante', 'si',prefijo.id.cnumcont,prefijo.id.cprefijo]);
	}

	eliminar(prefijo: m.PrefijoModel): void {

		console.log("VA A ELIMINAR ...");
		this._serviciosGenerales.get('consultarValidarFacturaPrefijo', { ciddoc: prefijo.id.cprefijo, ntipoempresa: -1 }).subscribe(result => {
			if (result[0].conteo > 0) {
				this.openSnackBarEspecial("No se puede eliminar porque ya existen facturas con este prefijo", "X");
			} else {
				this.confirmarEliminacionService.abrirDialog({ cnumcont: this.cnumcont.idOpcion, cprefijo: prefijo.id.cprefijo }, 'eliminarPrefijo');
				this.confirmarEliminacionService.eventoFin$.subscribe(r => {
					this.cargarTabla();
				})
			}


		}, error => {
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el prefijo", "X");
		})


		console.log(prefijo);

	}


	agregar() {
		if (this.cnumcont.idOpcion != '') {
			console.log("Entró a agregar");
			this._router.navigate(['/Prefijo', this.cnumcont.idOpcion, '']);
		} else {
			this.openSnackBarEspecial("Debe seleccionar un negocio para poder añadir un prefijo", "X");
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}





// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class PrefijosDatabase {

	dataChange: BehaviorSubject<m.PrefijoModel[]> = new BehaviorSubject<m.PrefijoModel[]>([]);

	get data(): m.PrefijoModel[] {
		return this.dataChange.value;
	}

	addPrefijo(prefijo: m.PrefijoModel) {
		const copiedData = this.data.slice();
		copiedData.push(prefijo);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: PrefijosDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<m.PrefijoModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: m.PrefijoModel) => {
				let searchStr = (item.id.cprefijo).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}


@Component({
	selector: 'confirmarDelete',
	templateUrl: 'ConfirmarDelete.component.html',
})
export class ConfirmarDelete {

	constructor(
		public dialogRef: MatDialogRef<ConfirmarDelete>,
		@Inject(MAT_DIALOG_DATA) public data: any) { }
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/PrefijoIndex.component.ts